import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../api";
import AuthContext from "../../context/AuthContext";

/* TipTap */
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import { TextStyle } from "@tiptap/extension-text-style";
import { Color } from "@tiptap/extension-color";
import { TextAlign } from "@tiptap/extension-text-align";
import { Underline } from "@tiptap/extension-underline";
import { Highlight } from "@tiptap/extension-highlight";
import { Subscript } from "@tiptap/extension-subscript";
import { Superscript } from "@tiptap/extension-superscript";
import { Link } from "@tiptap/extension-link";
import { Placeholder } from "@tiptap/extension-placeholder";
import { FontFamily } from "@tiptap/extension-font-family";

/* Custom extensions */
import FontSize from "./FontSizeExtension";
import MathExtension from "./MathExtension";
import CustomImageExtension from "./CustomImageExtension";
import MenuBar from "./MenuBar";

import "./TipTapEditor.css";

const CustomerAddBlog = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [loading, setLoading] = useState(false);

  /* -------------------------------------------------- */
  /* TipTap editor (SAME AS ADMIN)                      */
  /* -------------------------------------------------- */
  const editor = useEditor({
    extensions: [
      StarterKit,
      TextStyle,
      FontFamily,
      FontSize,
      Color,
      Underline,
      Highlight.configure({ multicolor: true }),
      Subscript,
      Superscript,
      Link.configure({ openOnClick: false }),
      TextAlign.configure({
        types: ["heading", "paragraph"],
      }),
      Placeholder.configure({
        placeholder: "Start writing your blog...",
      }),
      MathExtension,
      CustomImageExtension, // ✅ images via URL
    ],
    content: "",
  });

  /* -------------------------------------------------- */
  /* Image upload handler                               */
  /* -------------------------------------------------- */
  const handleImageUpload = async () => {
    if (!editor) return;

    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    input.click();

    input.onchange = async () => {
      const file = input.files[0];
      if (!file) return;

      const formData = new FormData();
      formData.append("file", file);

      const res = await api.post("/api/blog/upload-image", formData);

      editor
        .chain()
        .focus()
        .setImage({ src: res.data.url })
        .run();
    };
  };

  /* -------------------------------------------------- */
  /* Submit blog (CUSTOMER → PENDING)                   */
  /* -------------------------------------------------- */
  const submit = async () => {
    if (!title || !editor || editor.isEmpty) {
      alert("Title and content required");
      return;
    }

    if (!user) {
      alert("You must be logged in");
      return;
    }

    setLoading(true);
    try {
      await api.post("/api/blog/create", {
        title,
        textContent: JSON.stringify(editor.getJSON()),
        postedByEmail: user.username,
        postedByType: user.customerType, // ✅ CUSTOMER / STUDENT
      });

      alert("✅ Blog submitted for approval!");

      navigate("/customer/customersroleblogs"); // adjust route if needed
    } catch (err) {
      console.error(err);
      alert("❌ Failed to submit blog");
    } finally {
      setLoading(false);
    }
  };

  /* -------------------------------------------------- */
  /* Render                                             */
  /* -------------------------------------------------- */
  return (
    <div className="editor-container">
      <div className="editor-header-controls">
        <h4 className="fw-bold mb-3">✍️ Add New Blog</h4>

        <input
          className="form-control mb-3"
          placeholder="Blog Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />

        {/* Menu bar */}
        {editor && (
          <MenuBar editor={editor} onImageUpload={handleImageUpload} />
        )}
      </div>

      <div className="editor-content-wrapper">
        <EditorContent editor={editor} className="tiptap-editor" />
      </div>

      <div className="d-flex justify-content-between mt-3 px-3 pb-3">
        <button
          className="btn btn-outline-secondary"
          onClick={() => navigate(-1)}
        >
          ← Back
        </button>

        <button
          className="btn btn-primary"
          disabled={loading}
          onClick={submit}
        >
          {loading ? "Submitting..." : "Submit for Approval"}
        </button>
      </div>
    </div>
  );
};

export default CustomerAddBlog;
